export const COURSE = 'course';
export const COURSE_SUBSCRIPTION = 'course_subscription';
export const REGULAR_CLASS = 'regular_class';
export const REGULAR_CLASS_SUBSCRIPTION = 'regular_class_subscription';
export const COURSE_GROUP_PASS = 'course_group_pass';

export const COURSE_TYPES = [COURSE, COURSE_SUBSCRIPTION];
export const REGULAR_CLASS_TYPES = [REGULAR_CLASS, REGULAR_CLASS_SUBSCRIPTION];
export const GROUP_PASS_TYPES = [COURSE_GROUP_PASS];



// WEBPACK FOOTER //
// ./app/constants/sellingTypes.js